<template>
  <div id="app" v-loading="loading" element-loading-text="接口地址错误，请联系技术部修改" element-loading-spinner="el-icon-error"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <!-- <el-button @click="daochu" type="primary">翻译导出</el-button> -->

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- 工具 -->
    <tool />


  </div>

</template>
<script>

import tool from './components/tool/index'
export default {
  components: { tool },
  data() {
    return {
      loading: false,
      tableData: [],
      a: 1
    }
  },

  created() {

    if (location.host.indexOf('.com') !== -1 && this.baseURL != 'https://apimanage.rakumart.com') {
      this.loading = true
    }




  },
  mounted() {
    // window.addEventListener('message', (e) => {
    //   console.log(e);
    // })
  },
  methods: {
    //   翻译导出
    daochu() {
      this.tableData = this.$router.options.routes[0].children
      this.tableData.forEach((item, index) => {
        item.index = index + 1
      })

      //   this.tableData = [];
      //   for (let key in messagezh.message) {
      //     this.tableData.push({
      //       name: key,
      //       zh: messagezh.message[key],
      //       translate: "",
      //     });
      //   }
      //   for (let key in messageen.message) {
      //     for (let j = 0; j <= this.tableData.length; j++) {
      //       this.tableData[j].index = j + 1;
      //       if (key == this.tableData[j].name) {
      //         this.tableData[j].translate = messageen.message[key];
      //         break;
      //       }
      //     }
      //   }
      this.handleExportExcel()
    },
    geta() {
      require.ensure([], () => {
        const { export_json_to_excel } = require('./utlis/Export2Excel')
        const tHeader = ['路由', '页面', 'icon']
        const filterVal = ['path']
        const list = JSON.parse(localStorage.getItem('list'))
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '路由')
      })
    },
    // excel导出
    handleExportExcel(list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('./utlis/Export2Excel')
        const tHeader = ['NO', '路由名称', '页面名称']
        const filterVal = ['index', 'name', '']
        const list = this.tableData //把data里的tableData存到list
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '路由列表')
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
  },
}
</script>
<style lang="scss">
@import './css/mixin.scss';

html,
body,
#app {
  height: 100%;


}


.el-dialog__headerbtn {
  font-size: 40px !important;

}
</style>
